import axios from "axios";
import { pushToast } from "../utils/pushToast";
import { useState } from "react";
var changeForcePassword = false
const apiUrl = process.env.REACT_APP_API_KEY;

const client = axios.create({
    baseURL: apiUrl,
})

client.defaults.headers.common.Accept = 'application/json';
client.defaults.headers.common['Accept-Language'] = "fa";
client.defaults.headers.common['Content-Type'] = 'application/json';

client.interceptors.request.use(request => {
    const token = localStorage.getItem("token");
    const adminToken = localStorage.getItem("adminToken");

    // ارسال توکن کاربر
    if (token) {
        request.headers["Authorization"] = `Bearer ${token}`;
    }

    // ارسال توکن ادمین در هدر جدا
    if (adminToken) {
        request.headers["AuthorizationAdmin"] = `Bearer ${adminToken}`;
        // یا:
        // request.headers["X-Admin-Authorization"] = `Bearer ${adminToken}`;
    }

    if (changeForcePassword === false || request.url === 'User/ChangeUserPasswordByUser' || 'Authentication/Logout' || 'Authentication/LoginUser' || 'Authentication/VerifyUser')
        return request;
    else
        window.location.replace("/change-password")

})

client.interceptors.response.use((response) => {
    if (response.data?.apiVersion && response.data.apiVersion !== process.env.REACT_APP_VERSION) {
        window.location.reload();
    }
    return response;
}, (error) => {
    if (error.code === "ERR_NETWORK" && window.location.pathname !== "/coming-soon") {
        window.location.replace("/coming-soon")
        return
    }
    if (error.response.status === 401) {
        removeToken();
        window.location.replace("/login")
        return
    }
    if (error.response.status === 403) {
        pushToast("خطای دسترسی", "error")
    }
    if (error.response.status === 503) {
        window.location.replace("/coming-soon")
        return
    }
    return Promise.reject(error)
})

export const setToken = (token) => {
    localStorage.setItem('token', token);
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export const setAdminToken = () => {
    localStorage.setItem('adminToken', localStorage.getItem('token'));
    //client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
export const setReturnToAdmin = () => {
    localStorage.setItem('token', localStorage.getItem('adminToken'));
    client.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    localStorage.setItem('adminToken', null);
    console.log(localStorage.getItem('adminToken'))
}

const removeToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('adminToken');
    client.defaults.headers.common['Authorization'] = "";
}

export const login = async (values) => {
    client.defaults.headers.common['Authorization'] = ``;
    const { data } = await client.post(`Authentication/LoginUser`, values);
    // if(data?.userInfo?.data?.requiredChangePassword === true ){
    //     window.location.replace("/change-password")
    //     changeForcePassword= true
    // }
    return data;
}

export const loginWithUserId = async (id) => {
    //client.defaults.headers.common['Authorization'] = ``;
    const { data } = await client.get(`User/LoginWithUserId/${id}`);

    return data;
}

export const me = async () => {
    const { data } = await client.post(`Public/UserInfo`);

    if (data.userInfo?.data.requiredChangePassword === true) {
        changeForcePassword = true
    }
    return data;
}
export const logout = async (values) => {
    const { data } = await client.post(`Authentication/Logout`, values);
    removeToken();
    return data;
}

export const getSetting = async () => {
    const { data } = await client.get(`Public/GetSetting`);
    return data;
}
export const register = async (values) => {
    const { data } = await client.post(`Authentication/RegisterUser`, values);
    return data;
}

export const GetChangePasswordToken = async (mobile) => {
    const { data } = await client.get(`Authentication/GetChangePasswordToken/${mobile}`);
    return data;
}

export const ConfirmChangePasswordCode = async (values) => {
    const { data } = await client.post(`Authentication/ConfirmChangePasswordCode`, values);
    return data;
}
export const UserChangePassword = async (values) => {
    const { data } = await client.post(`Authentication/UserChangePassword`, values);
    return data;
}

export const checkUserIsValidate = async (values) => {
    const { data } = await client.post(`Authentication/CheckUserIsValidate`, values);
    return data;
}

export const forgetPassword = (values) => {
    const { data } = client.post(`forget-password`, values);
    return data;
}

export const resetPassword = (values) => {
    const { data } = client.post(`Authentication/resetPassword`, values);
    return data;
}


export const verifyUser = async (values) => {
    const { data } = await client.post(`Authentication/VerifyUser`, values);
    return data;
}
export const UserReferencerList = async () => {
    const { data } = await client.get(`Authentication/GetUserReferencerList`);
    return data;
}

export const verifyEmail = () => {
    const { data } = client.get(`verify-email`);
    return data;
}

export const ChangeUserPasswordByUser = async (values) => {
    const { data } = await client.post(`User/ChangeUserPasswordByUser`, values);
    if (data.status === 200) {
        changeForcePassword = false
    }
    return data;
}

export const ChangeUserPassword = async (id) => {
    const { data } = await client.get(`User/ChangeUserPassword/${id}`);
    if (data.status === 200) {
        changeForcePassword = false
    }
    return data;
}
export const ChangeActiveStatus = async (id) => {
    const { data } = await client.get(`User/ChangeActiveStatus/${id}`);
    if (data.status === 200) {
        changeForcePassword = false
    }
    return data;
}
// common

export const languages = async () => {
    const { data } = await client.get(`Common/GetListLanguage`);
    return data;
}

// User
export const users = async (values) => {
    const { data } = await client.post(`User/UserList`, values);
    return data;
}
export const userSubSet = async (values) => {
    const { data } = await client.post(`User/SubSetUser`, values);
    return data;
}
export const userSubSetTree3 = async (values) => {
    const { data } = await client.post(`User/SubSetUserTree3`, values);
    return data;
}

export const user = async (id) => {
    const { data } = await client.get(`User/UserItem/${id}`);
    return data;
}

export const createUser = async (values) => {
    const { data } = await client.post(`User/AddNewUser`, values)
    return data;
}

export const updateUser = async (id, values) => {
    const { data } = await client.patch(`User/EditUser/${id}`, values)
    return data;
}
export const uploadExcelFile = async (values) => {
    const { data } = await client.post(`User/UploadExcelFile`, values)
    return data;
}
export const deleteUser = async (id) => {
    const { data } = await client.delete(`User/RemoveUser/${id}`)
    return data;
}

export const updateUserRole = async (values) => {
    const { data } = await client.patch(`User/UpdateUserRole`, values)
    return data;
}

// permission category

export const permissionCategories = async (values) => {
    const { data } = await client.post(`PermissionCategory/PermissionCategoryList`, values);
    return data;
}

export const permissionCategory = async (id) => {
    const { data } = await client.get(`PermissionCategory/PermissionCategoryItem/${id}`);
    return data;
}

export const createPermissionCategory = async (values) => {
    const { data } = await client.post(`PermissionCategory/AddPermissionCategory`, values);
    return data;
}

export const deletePermissionCategory = async (id) => {
    const { data } = await client.delete(`PermissionCategory/RemovePermissionCategory/${id}`);
    return data;
}

export const updatePermissionCategory = async (id, values) => {
    const { data } = await client.patch(`PermissionCategory/EditPermissionCategory/${id}`, values);
    return data;
}

export const permissionCategoryList = async () => {
    const { data } = await client.get(`Permission/GetPermissionWithCategoryList`);
    return data;
}

// Role
export const roles = async (values) => {
    const { data } = await client.post(`Role/RoleList`, values);
    return data;
}

export const role = async (id) => {
    const { data } = await client.get(`Role/GetRoleItem/${id}`);
    return data;
}

export const createRole = async (values) => {
    const { data } = await client.post(`Role/AddRole`, values);
    return data;
}

export const deleteRole = async (id) => {
    const { data } = await client.delete(`Role/RemoveRole/${id}`);
    return data;
}

export const updateRole = async (id, values) => {
    const { data } = await client.patch(`Role/EditRole/${id}`, values);
    return data;
}

export const updateRolePermission = async (values) => {
    const { data } = await client.patch(`Role/UpdateRolePermission`, values);
    return data;
}

//permission
export const permissions = async (values) => {
    const { data } = await client.post(`Permission/PermissionList`, values);
    return data;
}

export const permission = async (id) => {
    const { data } = await client.get(`Permission/GetPermissionItem/${id}`);
    return data;
}

export const createPermission = async (values) => {
    const { data } = await client.post(`Permission/AddPermission`, values)
    return data;
}

export const deletePermission = async (id) => {
    const { data } = await client.delete(`Permission/RemovePermission/${id}`);
    return data;
}

export const updatePermission = async (id, values) => {
    const { data } = await client.patch(`Permission/EditPermission/${id}`, values);
    return data;
}
//City

export const cities = async (values) => {
    const { data } = await client.post(`City/CityList`, values);
    return data;
}
export const city = async (id) => {
    const { data } = await client.get(`City/CityItem/${id}`);
    return data;
}
export const deleteCity = async (id) => {
    const { data } = await client.delete(`City/RemoveCity/${id}`);
    return data;
}
export const createCity = async (values) => {
    const { data } = await client.post(`City/AddCity`, values);
    return data;
}
export const updateCity = async (id, values) => {
    const { data } = await client.patch(`City/EditCity/${id}`, values);
    return data;
}
export const GetAllCityList = async (id) => {
    const { data } = await client.get(`City/GetAllCityList/${id}`);
    return data;
}
//State

export const states = async (values) => {
    const { data } = await client.post(`State/StateList`, values);
    return data;
}
export const stateData = async (id) => {
    const { data } = await client.get(`State/StateItem/${id}`);
    return data;
}
export const deleteState = async (id) => {
    const { data } = await client.delete(`State/RemoveState/${id}`);
    return data;
}
export const createState = async (values) => {
    const { data } = await client.post(`State/AddState`, values);
    return data;
}
export const updateState = async (id, values) => {
    const { data } = await client.patch(`State/EditState/${id}`, values);
    return data;
}
export const GetAllStateList = async () => {
    const { data } = await client.get(`State/GetAllStateList`);
    return data;
}
//Advertisement

export const advertisements = async (values) => {
    const { data } = await client.post(`Advertisement/AdvertisementList`, values);
    return data;
}
export const advertisement = async (id) => {
    const { data } = await client.get(`Advertisement/AdvertisementItem/${id}`);
    return data;
}
export const deleteAdvertisement = async (id) => {
    const { data } = await client.delete(`Advertisement/RemoveAdvertisement/${id}`);
    return data;
}
export const createAdvertisement = async (values) => {
    const { data } = await client.post(`Advertisement/AddAdvertisement`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const updateAdvertisement = async (id, values) => {
    const { data } = await client.patch(`Advertisement/EditAdvertisement/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const ShowAdv = async () => {
    const { data } = await client.get(`Advertisement/ShowAdv/`);
    return data;
}
export const getUserAdv = async (id) => {
    const { data } = await client.get(`Advertisement/GetUserAdv/${id}`);
    return data;
}
//Profile
export const getCurrentUserData = async () => {
    const { data } = await client.get(`User/GetCurrentUserItem`);
    return data;
}
export const GetUserCompleteData = async () => {
    const { data } = await client.get(`User/GetUserCompleteData`);
    return data;
}

export const EditCurrentUser = async (values) => {
    const { data } = await client.patch(`User/EditCurrentUser`, values);
    return data;
}
export const EditCurrentUserBankInfo = async (values) => {
    const { data } = await client.patch(`User/EditCurrentUserBankInfo`, values);
    return data;
}

export const getTotalPrice = async () => {
    const { data } = await client.post(`Wallet/GetTotalWallet`);
    return data;
}

export const getUserRefrenceCode = async () => {
    const { data } = await client.get(`User/getUserRefrenceCode`);
    return data;
}
export const getInternetPackage = async (id) => {
    const { data } = await client.post(`ChargeMobile/InternetPackages/${id}`);
    return data;
}
export const GetBillPaymentStatus = async (id) => {
    const { data } = await client.get(`ChargeMobile/GetBillPaymentStatus/${id}`);
    return data;
}
export const chargeMobile = async (values) => {
    const { data } = await client.post(`ChargeMobile/ChargeMobile`, values);
    return data;
}

export const GetBillStatus = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetBillStatus`, values);
    return data;
}
export const PayBill = async (values) => {
    const { data } = await client.post(`ChargeMobile/PayBill`, values);
    return data;
}

export const getSearchUser = async (values) => {
    const { data } = await client.post(`User/GetSearchUser`, values);
    return data;
}

//Plan1
export const ListUserPlan2 = async () => {
    const { data } = await client.get(`Plan2/ListUserPlan2`);
    return data;
}

export const ActivePlan2 = async (id) => {
    const { data } = await client.get(`Plan2/ActivePlan/${id}`);
    return data;
}
export const GetAllCommissionForUser = async (values) => {
    const { data } = await client.post(`Plan1/GetAllCommissionForUser`, values);
    return data;
}
export const GetLockCommissionForUser = async () => {
    const { data } = await client.get(`Plan1/GetLockCommissionForUser`);
    return data;
}
export const ListUserPlan = async (planId) => {
    const { data } = await client.get(`Plan/ListUserActivePlan`, {
        params: { planId }
    });
    return data;
}


export const ActivePlan = async (id) => {
    const { data } = await client.get(`Plan/ActivePlan/${id}`);
    return data;
}

export const GetDownlineCount = async () => {
    const { data } = await client.get(`BinaryPlan/GetDownlineCount`);
    return data;
}

export const GetCommisionTransactions = () => {
    return client.get("/binaryplan/gettransactions");
};

export const GetTotalCommission = async () => {
    const { data } = await client.get("/BinaryPlan/GetTotalCommission");
    return data; // ResultDto
};

export const PurchaseAgentInsurance = async (amount) => {
    const { data } = await client.post(`/AgentInsurance/purchase?amount=${amount}`);
    return data;
};

export const IsExistInTreeInsurancePlan = async () => {
    const { data } = await client.get(`/AgentInsurance/IsExistsUserInTree`);
    return data;
};

export const GetAgentInsuranceDashboard = async () => {
    const { data } = await client.get(`/AgentInsurance/dashboard`);
    return data;
};

export const GetMyReferrer = async () => {
    const { data } = await client.get(`/AgentInsurance/getMyReferrer`);
    return data;
};

export const GetSupporterInfo = async (code) => {
    const { data } = await client.get(`/AgentInsurance/getSupporterInfo?userSupporterCode=${code}`);
    return data;
};

export const RegisterMembership = async (input) => {
    const { data } = await client.post(`/AgentInsurance/registerMembership`, input);
    return data;
};
export const GetAgentInsuranceStats = async () => {
    const { data } = await client.get(`/AgentInsurance/GetAgentInsuranceStats`);
    return data;
};
export const GetAgentInsuranceCommissionTransactions = async () => {
    const { data } = await client.get(`/AgentInsurance/GetCommissionTransactions`);
    return data;
};

export const GetAgentInsuranceNodes = async (groupId, isDirect = false) => {
    return await client.get(
        `/AgentInsurance/GetAgentInsuranceNodes?groupId=${groupId}&isDirect=${isDirect}`
    );
};

export async function GetAgentInsuranceGroupSettings() {
      const { data } = await client.get(`/AgentInsurance/GetGroupSettings`);
    return data;
}

export async function SaveAgentInsuranceGroupSettings(settings) {
    const { data } = await client.post(`/AgentInsurance/SaveGroupSettings`, settings);
    return data;
}

//City

export const GetAdminWalletList = async (values) => {
    const { data } = await client.post(`Wallet/GetAdminWalletList`, values);
    return data;
}
export const GetUserWalletList = async (values) => {
    const { data } = await client.post(`Wallet/GetUserWalletList`, values);
    return data;
}
export const RequestPaymentListForAdmin = async (values) => {
    const { data } = await client.post(`Wallet/RequestPaymentListForAdmin`, values);
    return data;
}
export const RequestPaymentListForUser = async (values) => {
    const { data } = await client.post(`Wallet/RequestPaymentListForUser`, values);
    return data;
}
export const AdminChargeWallet = async (values) => {
    const { data } = await client.post(`Wallet/AdminChargeWallet`, values);
    return data;
}
export const AdminChargeAdv = async (values) => {
    const { data } = await client.post(`Advertisement/AdminChargeAdv`, values);
    return data;
}

// export const city = async (id) => {
//     const {data} = await client.get(`City/CityItem/${id}`);
//     return data;
// }
// export const deleteCity = async (id) => {
//     const {data} = await client.delete(`City/RemoveCity/${id}`);
//     return data;
// }
// export const createCity = async (values) => {
//     const {data} = await client.post(`City/AddCity`, values);
//     return data;
// }
// export const updateCity = async (id, values) => {
//     const {data} = await client.patch(`City/EditCity/${id}`, values);
//     return data;
// }

//Report
export const CommissionPeriodForAdmin = async (values) => {
    const { data } = await client.post(`Commission/CommissionPeriodForAdmin`, values);
    return data;
}
export const CommissionForAdmin = async (values) => {
    const { data } = await client.post(`Commission/CommissionForAdmin`, values);
    return data;
}
export const UserCommission = async () => {
    const { data } = await client.get(`Commission/UserCommission`);
    return data;
}
export const CommissionUserGetAll = async (values) => {
    const { data } = await client.post(`Commission/UserGetAll`, values);
    return data;
}


export const GetUserInternetChargeListForAdmin = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetUserInternetChargeListForAdmin`, values);
    return data;
}
export const GetUserInternetChargeList = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetUserInternetChargeList`, values);
    return data;
}
export const GetUserSimChargeListForAdmin = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetUserSimChargeListForAdmin`, values);
    return data;
}
export const GetUserSimChargeList = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetUserSimChargeList`, values);
    return data;
}


//RequestPayment
export const AddRequestPaymentCommission = async (values) => {
    const { data } = await client.post(`RequestPayment/AddRequestPaymentCommission`, values);
    return data;
}

export const AddTransferCommissionToWallet = async (values) => {
    const { data } = await client.post(`RequestPayment/AddTransferCommissionToWallet`, values);
    return data;
}

export const AddTransferCommissionToPromotion = async (values) => {
    const { data } = await client.post(`RequestPayment/AddTransferCommissionToPromotion`, values);
    return data;
}

export const CheckRequestPayment = async () => {
    const { data } = await client.post(`RequestPayment/CheckRequestPayment`);
    return data;
}


export const GetUserRequestPayment = async (values) => {
    const { data } = await client.post(`RequestPayment/GetUserRequestPayment`, values);
    return data;
}
export const GetUserRequestPaymentForAdmin = async (values) => {
    const { data } = await client.post(`RequestPayment/GetUserRequestPaymentForAdmin`, values);
    return data;
}
export const GetUserRequestTransferCommissionToWallet = async (values) => {
    const { data } = await client.post(`RequestPayment/GetUserRequestTransferCommissionToWallet`, values);
    return data;
}
export const GetUserRequestTransferCommissionToWalletForAdmin = async (values) => {
    const { data } = await client.post(`RequestPayment/GetUserRequestTransferCommissionToWalletForAdmin`, values);
    return data;
}
export const UpdateRequestPaymentStatus = async (values) => {
    const { data } = await client.post(`RequestPayment/UpdateRequestPaymentStatus`, values);
    return data;
}

export const UserTree = async (id) => {
    const { data } = await client.get(`User/UserTree/${id}`);
    return data;
}

export const ParentUserTree = async (id) => {
    const { data } = await client.get(`User/ParentUserTree/${id}`);
    return data;
}

//ShopCategory
export const shopCategories = async (values) => {
    const { data } = await client.post(`ShopCategory/ShopCategoryList`, values);
    return data;
}
export const shopCategory = async (id) => {
    const { data } = await client.get(`ShopCategory/ShopCategoryItem/${id}`);
    return data;
}
export const deleteShopCategory = async (id) => {
    const { data } = await client.delete(`ShopCategory/RemoveShopCategory/${id}`);
    return data;
}
export const createShopCategory = async (values) => {
    const { data } = await client.post(`ShopCategory/AddShopCategory`, values);
    return data;
}
export const updateShopCategory = async (id, values) => {
    const { data } = await client.patch(`ShopCategory/EditShopCategory/${id}`, values);
    return data;
}
export const AllShopCategory = async () => {
    const { data } = await client.get(`ShopCategory/AllShopCategory`);
    return data;
}

export const shops = async (values) => {
    const { data } = await client.post(`Shop/ShopList`, values);
    return data;
}
export const shop = async (id) => {
    const { data } = await client.get(`Shop/ShopItem/${id}`);
    return data;
}
export const createShop = async (values) => {
    const { data } = await client.post(`Shop/AddShop`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}



export const ChargeWalletWithIrandargah = async (value) => {
    const { data } = await client.post(`Wallet/ChargeWalletWithIrandargah`, value);
    return data;
}
export const ChargeWalletWithSep = async (value) => {
    const { data } = await client.post(`Wallet/ChargeWalletWithSep`, value);
    return data;
}
export const ChargeWalletWithSaman = async (value) => {
    const { data } = await client.post(`Wallet/ChargeWalletWithSaman`, value);
    return data;
}
export const ChargeWalletVerificationWithIrandargah = async (id) => {
    const { data } = await client.get(`Wallet/ChargeWalletVerificationWithIrandargah/${id}`);
    return data;
}
export const CheckOnlinePaymentWithIrandargah = async (id) => {
    const { data } = await client.get(`Wallet/CheckOnlinePaymentWithIrandargah/${id}`);
    return data;
}

//OnlinePaymentBank
export const OnlinePaymentBankList = async (values) => {
    const { data } = await client.post(`OnlinePaymentBank/OnlinePaymentBankList`, values);
    return data;
}
export const OnlinePaymentBankListForAdmin = async (values) => {
    const { data } = await client.post(`OnlinePaymentBank/OnlinePaymentBankListForAdmin`, values);
    return data;
}
export const CheckWalletVerificationWithIrandargah = async (id) => {
    const { data } = await client.get(`OnlinePaymentBank/ChargeWalletVerificationWithIrandargah/${id}`);
    return data;
}